<template>
  <div class="data-processing">
    <h2 class="text-center mb-6 mt-2">Data Processing</h2>
    <p class="font-weight-bold">Data Portability</p>
    <div v-html="dataPortability" />
    <p class="font-weight-bold mt-5">Data Deletion</p>
    <div v-html="dataDeletion" />
  </div>
</template>

<script>
const DATA_PORTABILITY = `Your data can be requested in a portable format, to export from the system.
  To request the personal data that Alvius holds on you please email us at <span class="email">Recruitment@towerhamlets.gov.uk</span>
  from the email address that is associated with your account. Your personal data will be sent to you as a series of CSV files. 
  Please note that while we will make every effort to respond to you in a swift and timely manner, we have up to one month to respond to your request.`;

const DATA_DELETION = `To delete all personal data that Alvius holds on you email us at <span class="email">Recruitment@towerhamlets.gov.uk</span>
  from the email address that is associated with your account. Doing so will delete your entire account,
  which will therefore withdraw you from all live applications and prevent you from applying from any roles
 through the system. Once this is done you will not be able to recover your data. Please note that while
  we will make every effort to respond to you in a swift and timely manner, we have up to one month to respond to your request.`;

export default {
  data() {
    return {
      dataPortability: DATA_PORTABILITY,
      dataDeletion: DATA_DELETION
    };
  }
};
</script>

<style lang="scss">
.data-processing {
  white-space: normal;
  .email {
    color: $primary-darker;
  }
}
</style>
